import { Paper, Stack } from '@mantine/core'
import React from 'react'
import LoginForm from './components/LoginForm'
import LoginLegalNotice from './components/LoginLegalNotice'
import RightFloating from '../components/RightFloating'
import ComplaintButton from '../components/ComplaintButton'

export default function Login() {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        backgroundColor: '#f5f5f5',
      }}
    >
      <div className="w-full" style={{ maxWidth: '480px' }}>
        <Paper
          p="xl"
          className="shadow-2xl"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.98)',
            borderRadius: '24px',
            border: 'none',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          }}
        >
          <Stack gap="xl">
            <LoginForm />
            <LoginLegalNotice />
          </Stack>
        </Paper>
      </div>

      <RightFloating>
        <ComplaintButton className="rounded-l-lg" />
      </RightFloating>
    </div>
  )
}
